"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInput = void 0;
const validator_1 = __importDefault(require("validator"));
function validateInput(field, value) {
    const messages = {
        accountName: 'Please enter an account name',
        storeName: 'Please enter an account name',
        subdomain: 'Please enter a valid subdomain',
        name: 'Please enter a valid name',
        email: 'Please enter a valid email',
        'terms-of-service': 'Please agree to the service agreement'
    };
    if (!value) {
        if (field.toLowerCase().includes('password')) {
            return 'Please enter a valid password';
        }
        if (field in messages) {
            return messages[field];
        }
    }
    if (field === 'email') {
        if (!validator_1.default.isEmail(value)) {
            return 'Please enter a valid email';
        }
    }
    return false;
}
exports.validateInput = validateInput;
